<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="col-sm-12 nopads">
    <transition name="fade">
      <div
        v-if="lights.length > 0"
        class="list-content result-table"
      >
        <vue3-datatable
          :rows="lights"
          :columns="fields"
          :pagination="false"
          :sticky-header="true"
          height="50vh"
          :sortable="true"
          skin="bh-table-compact"
          row-class="routa-table-row"
          cell-class="routa-table-cell"
          @row-click="rowClicked"
        >
          <template #contract="row">
            {{ row.value.contract.name }}
          </template>
          <template #station="row">
            {{ row.value.power_station.location_name }}
          </template>
          <template #status="row">
            {{ row.value.status }}
          </template>
        </vue3-datatable>
      </div>
    </Transition>
  </div>
</template>

<script>

import {timeUtils} from "@/components/mixins/TimeUtils";
import {streetLightHelper} from "@/components/mixins/StreetLightMixin";
import Vue3Datatable from '@bhplugin/vue3-datatable'
export default {
    name: 'StreetLightList',
    components: {Vue3Datatable},
    mixins: [timeUtils, streetLightHelper],
    props: {
        streetLights: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data() {
        return {
            sortBy: 'id',
            sortDesc: false,
            lights: [],
        }
    },
    computed: {
        fields() {
            return [
                {field: 'id', title: this.$t('common.id'), sort: true, headerClass: 'routa-table-header', type: 'number'},
                {field: 'city', title: this.$t('street_lights.city'), sort: true, headerClass: 'routa-table-header'},
                {field: 'street', title: this.$t('street_lights.street'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_number', title: this.$t('street_lights.road_number'), sort: true, headerClass: 'routa-table-header'},
                {field: 'road_section', title: this.$t('street_lights.road_section'), sort: true, headerClass: 'routa-table-header'},
                {field: 'distance', title: this.$t('street_lights.distance'), sort: true, headerClass: 'routa-table-header'},
                {field: 'status', title: this.$t('street_lights.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'station', title: this.$t('street_lights.station'), sort: true, headerClass: 'routa-table-header'},
            ]
        }
    },
    watch: {
        streetLights() {
            this.lights = []
            let temp = []
            this.streetLights.forEach(item => {
                let newItem = JSON.parse(JSON.stringify(item));
                newItem.station = item.power_station ? item.power_station.location_name : ''
                newItem.status = item.status ? this.getStatusString(item.status) : ''
                temp.push(newItem)
            })
            this.$nextTick(() => {
                this.lights = temp
            })
        }
    },
    methods: {
        rowClicked: function (details) {
            this.$emit('rowClicked', details)
        }
    }
}
</script>
